import styled from 'styled-components'

export default styled.button`
  background: #d6d6d6;
  color: #4b4b4b;
  border: 0;
  outline: none;
  border-radius: 0.4rem;
  font-weight: bold;
  height: 4rem;
  cursor: pointer;
  font-size: 1.4rem;
  width: 100%;
  transition: all 0.2s ease-in-out;

  @media (min-width: 992px) {
    max-width: 960px;
  }

  &.primary {
    background: #e41645;
    color: white;
  }

  &.loading {
    background-color: ${(props) => props.theme.palette.gray[50]};
    padding: 0.3rem;
    border-radius: 50%;
    min-width: 0 !important;
    width: 4rem;
    display: flex;
  }
`
